import { EvmContractAddresses } from '@repo/types-client';

import { baseContractAddresses } from './base';
import { ethereumContractAddresses } from './ethereum';
import { externalBaseContractAddresses } from './externalContracts';

export const evmContractAddresses: Readonly<EvmContractAddresses> = {
  ...ethereumContractAddresses,
  ...baseContractAddresses,
  ...externalBaseContractAddresses,
};
